import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";
import { Tab } from "bootstrap";

import Task from "../../models/Task";
import User from "../../models/User";

import templateContent from "./task-detail-panel.html";

import messageModalComponent from "../messageModal/messageModalComponent";
import taskManager from "../../managers/taskManager";

class TaskDetailPanelComponent extends Component {
	constructor () {
		super("taskDetailPanelComponent");

		this.addTemplate("", templateContent);
	}
	
	addTaskBtn_clickHandler () {
		const { currProject } = Shark.get();

		if (currProject && currProject.guid !== "") {
			const editingTask = new Task({
				ownerGuid: Shark.$store.currUser.guid,
				projectGuid: currProject.guid,
				valuationType: currProject.valuationType,
				status: 1,
			});

			editingTask.on("projectGuidChanged", () => Shark.render());
			editingTask.on("statusChanged", () => Shark.render());
			editingTask.on("valuationTypeChanged", () => Shark.render());
	
			Shark.set({
				editingTask,
				__isEditingTask: true,
			});
			// Shark.render();
			
			this.updateOrganizationUsersForPermission();
			this.toggleOpen();
		}
	}

	afterLoad () {
		const modalNode = document.querySelector("#taskDetailModal");
		
		if (modalNode) {
			this.modal = new Modal(modalNode);
			modalNode.removeEventListener("hidden.bs.modal", this.hiddenbsmodal_handler);
			modalNode.addEventListener("hidden.bs.modal", this.hiddenbsmodal_handler);
		}
	}

	cancelTaskEditBtn_clickHandler () {
		this.close();
	}

	close () {
		Shark.set({
			__isEditingTask: false,
			__taskDetailModalVisibile: false,
		});

		if (this.modal) {
			this.modal.hide();
		}
	}

	editTaskBtn_clickHandler (event, data) {
		event.preventDefault();
		event.stopPropagation();
		
		const selectedTaskGuid = data.guid.toString();
		const selectedTask = Shark.$store.taskList.find(item => item.guid === selectedTaskGuid);

		if (selectedTask) {
			// Queste sono tutte temporanee.
			selectedTask.on("projectGuidChanged", () => Shark.render());
			selectedTask.on("statusChanged", () => Shark.render());
			selectedTask.on("valuationTypeChanged", () => Shark.render());

			Shark.set({
				editingTask: selectedTask,
			});

			this.updateOrganizationUsersForPermission();

			// Shark.render();
			this.open();
		}
	}

	fastSaveField_keyupHandler (event) {
		// @Dave: mac users don't use control but command
		if (event.keyCode === 83 && event.ctrlKey) {
			this.saveEditingTask();
		}
	}

	hiddenbsmodal_handler () {
		// console.log("hiddenbsmodal_handler");
		Shark.set({
			__isEditingTask: false,
			__taskDetailModalVisibile: false,
		});
	}

	init () {
		this.addComponents([messageModalComponent]);

		Shark.set({
			_saveEditingTaskBtnStatusCSSClasses: "btn-success",
			__isEditingTask: false,
			__taskDetailModalVisibile: false,
		});
	}
	
	open () {
		const triggerEl = document.querySelector(`#taskDetailModal button[data-bs-target="#task-tab-pane"]`);
		Tab.getOrCreateInstance(triggerEl).show();

		Shark.set({
			__taskDetailModalVisibile: true,
		});

		if (this.modal) {
			// Dave: Questo serve per ora, non togliere!
			Shark.render();
			this.modal.show();
		}
	}

	async saveEditingTask () {
		const { editingTask } = Shark.get();

		if (editingTask) {
			const validationError = editingTask.validate();

			if (validationError.length > 0) {
				validationError.forEach(error => {
					document.querySelectorAll(`[data-sh-validate="${error.field}"]`).forEach(item => item.classList.remove("invalid")); 
					setTimeout(() => {
						document.querySelectorAll(`[data-sh-validate="${error.field}"]`).forEach(item => item.classList.add("invalid")); 
					}, 250);
				});

				let id = document.querySelector(`[data-sh-validate="${validationError[0].field}"]`).closest(".tab-pane").getAttribute("data-reference-tab");
				let errorTab = Tab.getInstance(document.getElementById(id));
				errorTab?.show();
			}
			else {
				Shark.set({
					_saveEditingTaskBtnStatusCSSClasses: "btn-warning disabled",
				});
				await taskManager.save(editingTask);
				Shark.set({
					newlyAddedTask: editingTask,
					_saveEditingTaskBtnStatusCSSClasses: "btn-success",
				});
				this.close();

				//Questo andrebbe fatto con un evento
				if (Shark.activePage.refreshTaskList) {
					Shark.activePage.refreshTaskList();
				}
			}
		}
	}

	saveEditingTaskBtn_clickHandler () {
		this.saveEditingTask();
	}

	// async saveTaskPermissionBtn_clickHandler () {
	// 	const { editingTask } = Shark.get();

	// 	if (editingTask) {
	// 		await taskManager.save(editingTask);
	// 		// close?
	// 	}
	// }

	// setTaskPermissionBtn_clickHandler () {
	// 	Shark.set({
	// 		__taskPermissionTrayVisibile: !Shark.get("__taskPermissionTrayVisibile"),
	// 	});
	// }

	taskDetailPanelNameField_changeHandler () {
		const { editingTask } = Shark.get();
		document.querySelectorAll(`[data-sh-prop="taskNameField"]`).forEach(item => editingTask.validateName() != [] ? item.classList.add("invalid") : item.classList.remove("invalid")); 
	}

	taskDetailPanelValuationTypeField_changeHandler () {
		const { editingTask } = Shark.get();
		document.querySelectorAll(`[data-sh-prop="taskValuationTypeField"]`).forEach(item => editingTask.validateValuationTypeGuid() != [] ? item.classList.add("invalid") : item.classList.remove("invalid")); 
	}


	toggleOpen () {
		if (Shark.$store.__taskDetailModalVisibile) {
			this.close();
		}
		else {
			this.open();
		}
	}

	toggleTaskEditing () {
		const { editingTask } = Shark.get();

		// console.log({editingTask});
		Shark.$store.__isEditingTask = !Shark.$store.__isEditingTask;
		editingTask.updateScreenWithModelValues();

		if (Shark.$store.__isEditingTask) {
			document.querySelectorAll("textarea").forEach(function (element) {
				element.style.boxSizing = "border-box";
				var offset = element.offsetHeight - element.clientHeight;
				const updateSize = event => {
					event.target.style.height = "auto";
					event.target.style.height = event.target.scrollHeight + offset + "px";
				};

				element.addEventListener("input", updateSize);
				updateSize({ target: element });
				// element.removeAttribute("data-autoresize");
			});
		}
	}

	async toggleTaskEditingBtn_clickHandler () {
		const { editingTask } = Shark.get();

		if (Shark.$store.__isEditingTask && editingTask.isDirty()) {
			const confirmResponse = await messageModalComponent.open(Shark.$store.labels.warning_changes_not_saved, {
				cancelButtonLabel: "Annulla le modifiche",
				okButtonLabel: "Continua a modificare",
				showCancelButton: true,
			});

			if (confirmResponse) {
				return;
			}

			if (editingTask.guid === "") {
				this.close();
			}
			else {
				editingTask.restore();
			}
		}
		if (editingTask.guid === "") {
			this.close();
		}
		else {
			this.toggleTaskEditing();
		}
	}
	
	updateOrganizationUsersForPermission () {
		const { allUserList, allUserMembershipList, currUser, currProject } = Shark.get();
		let { editingTask } = Shark.get();

		if (allUserList && allUserMembershipList && currProject) {
			const selectedOrganizationGuid = currProject.organizationGuid;

			if (selectedOrganizationGuid) {
				editingTask.parseUserTaskPermissions();
				
				// Dave: serve anche filtro per status o prendo solo quelle attive dalle API?
				const otherUserList = allUserList.filter(user => {
					if (user.guid === currUser.guid) {
						return false;
					}
					
					const membership = allUserMembershipList.find(membership => membership.userGuid === user.guid && membership.organizationGuid === selectedOrganizationGuid);

					if (membership) {
						user._nameInActiveOrganization = membership.inviteName;

						return true;
					}

					return false;
				});
				
				Shark.set({
					editingTask,
					otherUserList,
				});
			}
			// Alice: no org selected (case new project || case starter/free)
			else {
				currProject.__currUserCanSeeProjectCustomerField = currUser._feature_customer;
				currProject.__currUserCanSeeProjectEconomicField = false;
				currProject.__currUserCanChangePermission = currUser._feature_permission;
				currProject.__currUserCanEditProjectCustomerField = false;
				currProject.__currUserCanEditProjectEconomicField = false;
				currProject.__currUserCanEditProjectGenericField = true;
				currProject.__currUserCanEditProjectOrganizationField = [User.SUBSCRIPTION_TYPE_FREE, User.SUBSCRIPTION_TYPE_STARTER].includes(currUser.subscriptionType) ? false : true;
			}
		}
	}
}

const taskDetailPanelComponent = new TaskDetailPanelComponent();

Shark.registerComponent(taskDetailPanelComponent);

export default taskDetailPanelComponent;